/* dev-info-page.js */

document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.info-page');
    sections.forEach((section) => init(section));
  });
  
  function init(section) {
    initAccordion(section);
    initNavigation(section);
    initScrollSpy(section);
  }
  
  /* --- Accordion --- */
  
  function initAccordion(section) {
    section.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-accordion-trigger]');
      if (!trigger) return;
  
      const item = trigger.closest('[data-accordion-item]');
      if (!item) return;
  
      const panel = item.querySelector('[data-accordion-panel]');
      if (!panel) return;
  
      const isOpen = item.dataset.open === 'true';
  
      /* Close all other open items */
      section.querySelectorAll('[data-accordion-item][data-open="true"]').forEach((openItem) => {
        if (openItem === item) return;
        const openPanel = openItem.querySelector('[data-accordion-panel]');
        const openTrigger = openItem.querySelector('[data-accordion-trigger]');
        if (!openPanel) return;
        openItem.dataset.open = 'false';
        if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
        openPanel.style.height = openPanel.scrollHeight + 'px';
        requestAnimationFrame(() => { openPanel.style.height = '0'; });
        openPanel.addEventListener('transitionend', function onEnd() {
          openPanel.removeEventListener('transitionend', onEnd);
          openPanel.hidden = true;
          openPanel.style.height = '';
        });
      });
  
      if (isOpen) {
        /* Collapse: animate from current height to 0 */
        panel.style.height = panel.scrollHeight + 'px';
        requestAnimationFrame(() => {
          panel.style.height = '0';
        });
        panel.addEventListener('transitionend', function onEnd() {
          panel.removeEventListener('transitionend', onEnd);
          panel.hidden = true;
          panel.style.height = '';
        });
      } else {
        /* Expand: animate from 0 to scrollHeight, then clear inline height */
        panel.hidden = false;
        panel.style.height = '0';
        requestAnimationFrame(() => {
          panel.style.height = panel.scrollHeight + 'px';
        });
        panel.addEventListener('transitionend', function onEnd() {
          panel.removeEventListener('transitionend', onEnd);
          panel.style.height = '';
        });
      }
  
      item.dataset.open = isOpen ? 'false' : 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  }
  
  /* --- Sidebar navigation smooth scroll --- */
  
  function initNavigation(section) {
    const navLinks = section.querySelectorAll('[data-info-nav]');
    if (!navLinks.length) return;
  
    navLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.dataset.infoTarget;
        const targetGroup = section.querySelector(`[data-info-group="${targetId}"]`);
        if (!targetGroup) return;
  
        /* Set active immediately on click — no waiting for observer */
        setActiveLink(navLinks, targetId);
  
        /* Lock scroll spy so it doesn't fight the smooth scroll */
        section.dataset.scrollLocked = 'true';
  
        targetGroup.scrollIntoView({ behavior: 'smooth', block: 'start' });
  
        /* Unlock after scroll settles (debounced scroll-end detection) */
        let scrollTimer;
        const unlockOnScrollEnd = () => {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(() => {
            section.dataset.scrollLocked = 'false';
            window.removeEventListener('scroll', unlockOnScrollEnd);
          }, 100);
        };
        window.addEventListener('scroll', unlockOnScrollEnd, { passive: true });
  
        /* Fallback: unlock after 1s even if scroll events don't fire */
        setTimeout(() => {
          section.dataset.scrollLocked = 'false';
          window.removeEventListener('scroll', unlockOnScrollEnd);
        }, 1000);
      });
    });
  }
  
  /* --- Scroll spy for sidebar nav --- */
  
  function initScrollSpy(section) {
    const navLinks = section.querySelectorAll('[data-info-nav]');
    const groups = section.querySelectorAll('[data-info-group]');
    if (!navLinks.length || !groups.length) return;
  
    let ticking = false;
  
    const update = () => {
      if (section.dataset.scrollLocked === 'true') return;
  
      /* The reference line sits at 25% from the top of the viewport.
         The last group whose top has scrolled past this line is active. */
      const refLine = window.innerHeight * 0.25;
      let activeGroup = groups[0];
  
      for (const group of groups) {
        if (group.getBoundingClientRect().top <= refLine) {
          activeGroup = group;
        } else {
          break;
        }
      }
  
      setActiveLink(navLinks, activeGroup.dataset.infoGroup);
    };
  
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    }, { passive: true });
  
    /* Initial highlight on load */
    update();
  }
  
  /* --- Shared: update active nav link --- */
  
  function setActiveLink(navLinks, activeId) {
    navLinks.forEach((link) => {
      link.classList.toggle('is-active', link.dataset.infoTarget === activeId);
    });
  }
  